export default __webpack_public_path__ + "static/media/logo-white.8c7e7e90.svg";